import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { getDailyList } from '../utils/api';
import { printRegistrationSlip } from '../utils/printSlip';

const NAVY = '#0d2137';
const GREEN = '#1a6b3c';
const RED = '#c41e3a';

export default function DailyList() {
  const today = new Date().toISOString().split('T')[0];
  const [date, setDate] = useState(today);
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = (d) => {
    setLoading(true);
    getDailyList(d)
      .then(r => setVisits(r.data))
      .catch(() => toast.error('Failed to load list'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(date); }, [date]);

  const totalFees = visits.reduce((sum, v) => sum + Number(v.fees || v.doctor_fees || 0), 0);

  return (
    <div style={{ padding: '32px 28px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={{ color: NAVY, fontSize: 26, fontWeight: 900, marginBottom: 4 }}>Daily Patient List</h1>
          <div style={{ color: '#64748b', fontSize: 14 }}>{visits.length} patient{visits.length !== 1 ? 's' : ''} · PKR {totalFees.toLocaleString()} total fees</div>
        </div>
        <input
          type="date"
          value={date}
          onChange={e => setDate(e.target.value)}
          style={{ padding: '9px 14px', border: '1.5px solid #cbd5e1', borderRadius: 8, fontSize: 14, outline: 'none', color: NAVY, fontWeight: 600 }}
        />
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8' }}>Loading...</div>
      ) : visits.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8', fontSize: 15 }}>No patients registered on this date.</div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: NAVY, color: '#fff' }}>
                {['Token', 'MRN', 'Patient', 'Gender', 'Age', 'Phone', 'Doctor', 'Fees', 'Time', 'Print'].map(h => (
                  <th key={h} style={{ padding: '11px 12px', fontSize: 12, fontWeight: 700, textAlign: 'left', whiteSpace: 'nowrap' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {visits.map((v, i) => (
                <tr key={v.id} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                  <td style={{ padding: '10px 12px', fontWeight: 800, color: RED, fontSize: 13 }}>{v.visit_token}</td>
                  <td style={{ padding: '10px 12px', fontSize: 12, color: '#64748b' }}>{v.mrn}</td>
                  <td style={{ padding: '10px 12px', fontWeight: 700, color: NAVY }}>{v.patient?.full_name || v.full_name || '—'}</td>
                  <td style={{ padding: '10px 12px', fontSize: 12 }}>{v.patient?.gender || v.gender || '—'}</td>
                  <td style={{ padding: '10px 12px', fontSize: 12 }}>{v.age_years || v.patient?.age_years ? `${v.age_years || v.patient?.age_years}y` : '—'}</td>
                  <td style={{ padding: '10px 12px', fontSize: 12 }}>{v.patient?.phone || v.phone || '—'}</td>
                  <td style={{ padding: '10px 12px', fontSize: 12, color: GREEN, fontWeight: 600 }}>{v.doctor_name || v.doctor?.name || '—'}</td>
                  <td style={{ padding: '10px 12px', fontSize: 12, fontWeight: 700, color: GREEN }}>{v.fees || v.doctor_fees ? `PKR ${Number(v.fees || v.doctor_fees).toLocaleString()}` : '—'}</td>
                  <td style={{ padding: '10px 12px', fontSize: 11, color: '#64748b' }}>
                    {v.created_at ? new Date(v.created_at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true }) : '—'}
                  </td>
                  <td style={{ padding: '10px 12px' }}>
                    <button
                      onClick={() => printRegistrationSlip(
                        v.patient || v,
                        v.doctor_name ? { name: v.doctor_name, specialty: v.specialty, fees: v.fees || v.doctor_fees, room_number: v.room_number, timing: v.timing } : v.doctor,
                        v.mrn, v.visit_token
                      )}
                      style={{ padding: '5px 12px', background: NAVY, color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                      Print
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
